import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { srcDTO } from "src/app/data/schema/VideoPlayer/srcDTO";

export interface VideoEvent {
    currentTimeInSec: number;
    remainingTimeInSec: number;
    videoEnded: boolean;
    videoPaused: boolean;
    alreadyPlayed: boolean;
}

declare let videojs: any;

@Component({
    selector: "app-video-player",
    templateUrl: "./video-player.component.html",
    styleUrls: ["./video-player.component.scss"]
})
export class VideoPlayerComponent implements OnDestroy {
    private _src: string[];
    private _thumbnail: string;
    //public vhs_stats: any;

    @Input("externalMediaUrl")
    public externalMediaUrl?: string;

    @Input("src")
    get src(): string[] {
        return this._src;
    }
    set src(src: string[]) {
        this._src = src;

        if (this._src != null && this._src.length == 0) {
            this._src = null;
        }

        this.refreshOneTime();
    }

    @Input("thumbnail")
    get thumbnail(): string {
        return this._thumbnail;
    }
    set thumbnail(thumbnail: string) {
        if (thumbnail == undefined) thumbnail = null;
        this._thumbnail = thumbnail;

        this.refreshOneTime();
    }

    playerId: string;
    playerIds: string[] = [];

    source: srcDTO[];
    player: any;
    type: string;

    private timeout = null;

    @Input() blockAdvanceVideo: boolean;
    @Input("InitialTimeInSec") initialTimeInSec: number;
    @Output("VideoEvent") videoEventEmitter = new EventEmitter<VideoEvent>();

    lastVideoEvent: VideoEvent;
    videoAlreadyPlayed = false;

    constructor() {
        // setInterval(() => {
        //     try {
        //         this.vhs_stats = JSON.parse(JSON.stringify(this.player?.tech()?.vhs?.stats));
        //     } catch (err) {}
        // }, 1000);
    }

    getRandomInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    ngOnDestroy(): void {
        if (this.player != null) this.player.dispose();
    }

    refreshOneTime(): void {
        if (this.timeout != null) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            this.refresh();
            this.timeout = null;
        }, 500);
    }

    public refresh(): void {
        this.playerId = "playerId_" + this.getRandomInt(1000, 10000000);

        this.PlayerIdWaitLoad(() => {
            this.source = [];

            this.src.forEach((source) => {
                if (source.endsWith(".m3u8")) {
                    const resolution = source.split("/").pop()?.replace(".m3u8", "");

                    this.source.push({
                        src: source,
                        type: "application/x-mpegURL",
                        label: resolution
                    });
                } else {
                    const reg = /\/(?<resolution>[\w\d-]+)\.(?<extension>[\w\d-]+)\?.*$/g;
                    const regexec = reg.exec(source);
                    if (regexec == null) {
                        console.log("Url player invalid '" + source + "'");
                        return;
                    }

                    const groups = regexec.groups;

                    let type = "";
                    if (groups.extension.toLowerCase() == "m3u8") {
                        type = "application/x-mpegURL";
                    } else {
                        type = "video/" + groups.extension;
                    }
                    const resolution = groups.resolution;
                    const src = source;

                    this.source.push({
                        src: src,
                        type: type,
                        label: resolution
                    });
                }
            });

            this.player = videojs(this.playerId, {
                aspectRatio: "16:9",
                controls: true,
                autoplay: false,
                preload: "metadata",
                techOrder: ["html5"],
                playbackRates: [0.5, 1, 1.25, 1.5, 2],
                fluid: true,
                controlBar: {
                    pictureInPictureToggle: false
                },
                notSupportedMessage: "cannot play back :(",
                html5: {
                    vhs: {
                        liveRangeSafeTimeDelta: 60 * 2,
                        useBandwidthFromLocalStorage: true,
                        enableLowInitialPlaylist: false,
                        handlePartialData: true,
                        useNetworkInformationApi: true
                    }
                }
            });

            this.player.src(this.source);

            this.player.poster(this.thumbnail);

            this.player.hlsQualitySelector({
                displayCurrentQuality: true
            });

            //this.player.vhs.options_.externHls.GOAL_BUFFER_LENGTH = 60;
            //this.player.tech().vhs.liveRangeSafeTimeDelta = 30;
        });
    }

    private PlayerIdWaitLoad(afterLoad: () => void) {
        const intervalPlayerIdWaitLoad = setInterval(() => {
            if (document.getElementById(this.playerId) != null) {
                clearInterval(intervalPlayerIdWaitLoad);
                afterLoad();
                this.player?.currentTime(this.initialTimeInSec || 0);
                this.startEmitTime();
            }
        });
    }

    startEmitTime(): void {
        let maxWatched = this.initialTimeInSec || 0;
        setInterval(() => {
            try {
                if (!this.player) return;
                const currentTime = this.getPlayerTime().currentTimeInSec;
                if (
                    this.blockAdvanceVideo == true &&
                    maxWatched < currentTime &&
                    currentTime > this.lastVideoEvent?.currentTimeInSec + this.player.playbackRate() + 0.5
                )
                    this.player.currentTime(this.lastVideoEvent?.currentTimeInSec);

                this.videoAlreadyPlayed = this.videoAlreadyPlayed || this.player?.paused() == false;
                maxWatched = Math.max(maxWatched, this.getPlayerTime().currentTimeInSec);
                const event: VideoEvent = {
                    currentTimeInSec: this.getPlayerTime().currentTimeInSec || 0,
                    remainingTimeInSec: this.getPlayerTime().remainingTimeInSec || 0,
                    videoEnded: this.player?.ended() == true,
                    videoPaused: this.player?.paused() == true,
                    alreadyPlayed: this.videoAlreadyPlayed
                };

                const eventStr = JSON.stringify(event);
                if (JSON.stringify(this.lastVideoEvent) == eventStr) return;

                this.videoEventEmitter.emit(event);
                this.lastVideoEvent = event;
            } catch {}
        }, 1000);
    }

    getPlayerTime(): { currentTimeInSec: number; remainingTimeInSec: number } {
        return {
            currentTimeInSec: Number(this.player?.currentTime()?.toFixed()),
            remainingTimeInSec: Number(this.player?.remainingTime()?.toFixed())
        };
    }

    public pause(): void {
        this.player.pause();
    }

    validateUrl(value: string): boolean {
        return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
            value
        );
    }
}
